import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppContext from '../app/AppContext';
import axios from 'axios';
import './ResourceSection.css';
import { ReactComponent as HelpIcon } from '../../images/icons/help.svg';

class OrganisationTrophyCabinet extends Component {
    static contextType = AppContext;

    constructor (props) {
        super(props);

        this.state = {
            trophyCabinet: [],
            trophyExpanded: false
        };
    }

    componentDidMount () {
        this.getOrganisationTrophyCabinet();
    }

    getOrganisationTrophyCabinet = () => {
        const token = this.context.token ? this.context.token : localStorage.getItem('token');
        const headers = {
            Authorization: `Token ${token}`
        };
        /* eslint-disable-next-line*/
        let apiCallURL = `${process.env.REACT_APP_API_URL}/api/react/organisations/${this.context.selectedOrganisation.id}/trophy_cabinet/`;
        axios
            .get(apiCallURL, { headers })
            .then(res => {
                this.setState({
                    trophyCabinet: res.data.data
                });
            })
            .catch(error => {
                console.log('Could not retrieve organisation trophy cabinet', error);
                return null;
            });
    };

    render () {
        const { trophyCabinet, trophyExpanded } = this.state;

        const displayLimit = 4;
        const hasOverflow = trophyCabinet.length > displayLimit;
        const isExpanded = trophyExpanded;
        const awardsToShow = isExpanded ? trophyCabinet : hasOverflow ? trophyCabinet.slice(0, displayLimit) : trophyCabinet;
        const overflowCount = hasOverflow ? trophyCabinet.length - displayLimit : 0;
        const hasAwards = trophyCabinet.length > 0;
        const rowClass = `org-trophy-cabinet-row ${isExpanded ? 'expanded' : ''}`;

        if (!hasAwards) {
            return null;
        }

        return (
            <div className='org-trophy-cabinet-container'>
                <div className='org-trophy-cabinet-header'>
                    <h3>Organisation Trophy Cabinet</h3>
                    <div className='toolkit-header-btn org-trophy-cabinet-download-btn'>
                        <div role='button' className='btn primary-btn modal-form-btn' onClick={this.props.toggleAwardsModal}>
                            Download Racecheck awards
                        </div>
                    </div>
                </div>

                <div className={rowClass}>
                    {awardsToShow.map((item, index) => {
                        const { award, event_titles: eventTitles } = item;
                        const eventCount = Array.isArray(eventTitles) ? eventTitles.length : 0;
                        const showOverlay = hasOverflow && index === displayLimit - 1;
                        return (
                            <div className='org-trophy-card' key={award.id}>
                                <div className='org-trophy-card-img-wrapper'>
                                    <img src={award.image} alt={award.title} className='org-trophy-card-img' />
                                </div>
                                <div className='org-trophy-card-text'>
                                    <p className='org-trophy-card-title'>{award.short_title}</p>
                                    {eventCount > 0 && (
                                        <div className='org-trophy-card-events'>
                                            <div className='org-trophy-events-tooltip'>
                                                {eventCount} {eventCount === 1 ? 'event' : 'events'}
                                                <HelpIcon className='org-trophy-events-icon' />
                                                <div className='org-trophy-events-tooltiptext'>
                                                    {eventTitles.map(title => (
                                                        <p key={title}>&bull;&nbsp;{title}</p>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                {showOverlay && !isExpanded && (
                                    <button
                                        type='button'
                                        className='org-trophy-card-more'
                                        onClick={() => this.setState({ trophyExpanded: true })}
                                    >
                                        + {overflowCount}
                                        <span className='org-trophy-more'>&nbsp;more</span>
                                    </button>
                                )}
                            </div>
                        );
                    })}
                    {isExpanded && hasOverflow && (
                        <button
                            type='button'
                            className='org-trophy-show-less'
                            onClick={() => this.setState({ trophyExpanded: false })}
                        >
                            Show less
                        </button>
                    )}
                </div>
            </div>
        );
    }
}

OrganisationTrophyCabinet.propTypes = {
    toggleAwardsModal: PropTypes.func.isRequired,
};

export default OrganisationTrophyCabinet;
